import request from '@/utils/request';
const baseURL = '/api/posclient/';

//掃描
export function scan(data) {
  return request({
    timeout: 120000,
    loading: false,
    method: 'post',
    url: `${baseURL}scan`,
    data,
  });
}

//取消掃描
export function cancelScan(type, order_id) {
  return request({
    timeout: 120000,
    // loading: false,
    method: 'post',
    url: `${baseURL}cancelScan`,
    data: {
      scan_method: type,
      test_mode: 0,
      order_id,
    },
  });
}

//取得會員的電子券
export function getMemberTicket(data) {
  return request({
    timeout: 25000,
    loading: false,
    method: 'post',
    url: `${baseURL}getMemberTicket`,
    data,
  });
}

//核銷會員的電子券
export function redeemTicket(data) {
  return request({
    method: 'post',
    url: `${baseURL}redeemTicket`,
    data,
  });
}

//旺卡加值
export function addValue(data) {
  return request({
    method: 'post',
    url: `${baseURL}addValue`,
    data,
  });
}

//旺卡自動加值
export function cardLinkDeduct(data) {
  return request({
    method: 'post',
    url: `${baseURL}cardLinkDeduct`,
    data,
  });
}

//檢查統編
export function validateTaxId(invoice_no) {
  return request({
    method: 'post',
    url: `${baseURL}validateTaxId`,
    data: {
      invoice_no,
    },
  });
}
//檢查條碼
export function validateCarrierNo(data) {
  return request({
    method: 'post',
    url: `${baseURL}validateCarrierNo`,
    data,
  });
}

//檢查會員
export function validatePhoneMember(data) {
  // {
  //   "order_id": "7a29dcee-316b-4885-843a-f3625cf3a68d",
  //   "cell_phone": '0988666666',
  // }

  return request({
    method: 'post',
    url: `${baseURL}validatePhoneMember`,
    data,
  });
}

//將電話綁定到訂單
export function setPhoneMemberIntoOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}setPhoneMemberIntoOrder`,
    data,
  });
}

// 透過門號查詢會員資料
export function queryMemberInfoByPhone(data) {
  return request({
    method: 'post',
    url: `${baseURL}queryMemberInfoByPhone`,
    data,
  });
}

//透過門號查詢會員的電子票券清單
export function getMemberTicketByPhone(data) {
  return request({
    method: 'post',
    url: `${baseURL}getMemberTicketByPhone`,
    data,
  });
}
